var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from "../../I18N";

import { Pie, Bar } from "./..";

export class LibraryChartComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { type: 'pie' };
    this.maxPieItems = 14;
    this.assignType = this.assignType.bind(this);
    this.typeButton = this.typeButton.bind(this);
  }

  assignType(type) {
    return () => {
      this.setState({ type });
    };
  }

  clusterResults(options) {
    return options.reduce((_clusteredResults, option, optionIndex) => {
      const clusteredResults = _clusteredResults;
      if (optionIndex < this.maxPieItems) {
        clusteredResults.push(option);
      }

      if (optionIndex === this.maxPieItems) {
        clusteredResults.push({ label: t('System', 'Other'), results: option.results });
      }

      if (optionIndex > this.maxPieItems) {
        clusteredResults[clusteredResults.length - 1].results += option.results;
      }

      return clusteredResults;
    }, []);
  }

  typeButton(type) {
    const className = `btn btn-sm ${this.state.type === type ? 'btn-success' : 'btn-default'}`;
    return /*#__PURE__*/(
      _jsx("button", { className: className, onClick: this.assignType(type) }, void 0, /*#__PURE__*/
      _jsx("i", { className: `fa fa-${type}-chart` })
      ));

  }

  render() {
    if (!this.props.options) {
      return null;
    }

    const chart =
    this.state.type === 'pie' ? /*#__PURE__*/
    _jsx(Pie, { data: this.clusterResults(this.props.options) }) : /*#__PURE__*/

    _jsx(Bar, { data: this.props.options, chartLabel: this.props.label });


    return /*#__PURE__*/(
      _jsx("div", { className: "item item-chart" }, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: "item-chart-type" }, void 0,
      this.typeButton('pie'),
      this.typeButton('bar')
      ), /*#__PURE__*/
      _jsx("p", {}, void 0, this.props.label),
      chart
      )
      ));

  }
}

LibraryChartComponent.defaultProps = {
  options: [],
  label: null
};






export default connect()(LibraryChartComponent);